import { render, staticRenderFns } from "./IcoPrice.vue?vue&type=template&id=495b3b70&scoped=true"
import script from "./IcoPrice.vue?vue&type=script&lang=js"
export * from "./IcoPrice.vue?vue&type=script&lang=js"
import style0 from "./IcoPrice.vue?vue&type=style&index=0&id=495b3b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b3b70",
  null
  
)

export default component.exports